const NAME = "REASONS_FOR_POINT_AWARDING";

export default NAME;
